import React, { useMemo } from "react";

import { IActiveLearningIssue } from "../../../../../../state";
import MultipleTextArea from "../../../../../ActiveLearning/MultipleTextArea";
import Button from "../../../../../../atoms/ActiveLearning/Button";
import CommentList from "../../../../../../molecules/ActiveLearning/CommentList";
import styles from "../../../ActiveLearningIssue.module.scss";

type Issue2MaterialProps = {
  issue?: IActiveLearningIssue;
};

export const Issue2Material = (props: Issue2MaterialProps) => {
  const question1 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 1);
  }, [props.issue?.questions]);

  const question2 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 2);
  }, [props.issue?.questions]);

  const question3 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 3);
  }, [props.issue?.questions]);

  return (
    <div className={styles.issue}>
      <div className={styles.header}>
        <span className={styles.no}>
          WORK
          {props.issue?.no && props.issue?.no < 10
            ? `0${props.issue?.no}`
            : props.issue?.no}
        </span>
        <p className={styles.title}>{props.issue?.title}</p>
        <p className={styles.read}>
          もらったコメントを参考に自分の発表を振り返り、「問い」/「課題」/解決のアイデアについての良かった点/改善点を整理しよう。
        </p>
      </div>
      <div className={styles.commentList}>
        <div className={styles.label}>
          <p className={styles.title}>もらったコメント</p>
          <Button width={"150px"} height={"37px"} fontSize={"14px"}>
            コメントを読み込む
          </Button>
        </div>
        <CommentList commentList={[]} />
      </div>
      {question1 && (
        <div className={styles.themEntry}>
          <p className={styles.title}>{question1?.title}</p>
          <div className={styles.textAreaWrapper}>
            <MultipleTextArea goodLabel={"良かった点"} mottoLabel={"改善点"} />
          </div>
        </div>
      )}
      {question2 && (
        <div className={styles.themEntry}>
          <p className={styles.title}>{question2?.title}</p>
          <div className={styles.textAreaWrapper}>
            <MultipleTextArea goodLabel={"良かった点"} mottoLabel={"改善点"} />
          </div>
        </div>
      )}
      {question3 && (
        <div className={styles.themEntry}>
          <p className={styles.title}>{question3?.title}</p>
          <div className={styles.textAreaWrapper}>
            <MultipleTextArea goodLabel={"良かった点"} mottoLabel={"改善点"} />
          </div>
        </div>
      )}
    </div>
  );
};
export default Issue2Material;
